import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import dataComponent from '../hoc/dataComponent';
import { Link } from 'react-router';
import { FormattedMessage, defineMessages } from 'react-intl';

import * as Schema from '../schema';
import assembleEntity from '../schema/assembleEntity';

import * as Shapes from '../shapes';
import List from '../components/util/List';

import { loadGenres } from '../actions/genre';
import * as clientActions from '../actions/client';
import CapacitorRipple from '../components/capacitor/Ripple';
import { META_TITLE_PREFIX } from '../constants';

const messages = defineMessages({
  metaTitle: {
    id: 'genres.meta.title',
    defaultMessage: 'Genres',
  },
  metaDescription: {
    id: 'genres.meta.description',
    defaultMessage:
      'Quickly find and play classical music of various genres from our curated repertoire, including recordings from classical masters and contemporary artists.',
  },
  metaKeywords: {
    id: 'genres.meta.keywords',
    defaultMessage:
      'classical music genres, chamber music, concertos, classical orchestral music, classical vocal music, secular vocal, sacred vocal',
  },
});

class Genres extends Component {
  static propTypes = {
    genreList: PropTypes.arrayOf(Shapes.Category).isRequired,
  };

  static onDataFetch(store, params, location, intl) {
    store.dispatch(
      clientActions.setHelmet({
        title: META_TITLE_PREFIX + intl.formatMessage(messages.metaTitle),
        description: intl.formatMessage(messages.metaDescription),
        keywords: intl.formatMessage(messages.metaKeywords),
        canonicalRoute: '/genres',
      })
    );
  }

  renderGenreListItem(item) {
    return (
      <li key={item.id}>
        <Link to={`/genres/${item.id}`}>
          <CapacitorRipple />
          {item.title}
        </Link>
      </li>
    );
  }

  render() {
    return (
      <div className="genres u-page-container">
        <h1 className="fz--beta">
          <FormattedMessage id="genres.title" defaultMessage="Genres" />
        </h1>
        <List items={this.props.genreList} renderItem={this.renderGenreListItem.bind(this)} />
      </div>
    );
  }
}

function fetchData(store) {
  return store.dispatch(loadGenres());
}

function mapStateToProps(state) {
  return {
    entities: state.entities,
    genres: state.lists.genres.entities,
  };
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  const { entities, genres } = stateProps;
  const genreList = assembleEntity(Schema.GenreList, entities, genres);

  return Object.assign({}, ownProps, dispatchProps, {
    genreList,
  });
}

export default compose(dataComponent(fetchData), connect(mapStateToProps, {}, mergeProps))(Genres);
